const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://dienbien-api.cgis.asia/",
  },
  production: {
      api: "https://dienbien-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
